export class TicketNoteVm{
    Note: string;
}